import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: { name: 'Dashboard' }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: () =>
                import ('@/components/dashboard/Dashboard.vue')
        },
        {
            path: '/input',
            name: 'Input',
            component: () =>
                import ('@/components/input/Input.vue')
        },
        {
            path: '/output',
            name: 'Output',
            component: () =>
                import ('@/components/output/Output.vue')
        },
        {
            path: '/process',
            name: 'Process',
            component: () =>
                import ('@/components/process/Process.vue')
        },
        {
            path: '/reports',
            name: 'Reports',
            component: () =>
                import ('@/components/reports/Reports.vue')
        },
        {
            path: '/settings',
            name: 'Settings',
            component: () =>
                import ('@/components/settings/Settings.vue')
        },
        // {
        //     path: '*',
        //     name: 'Pagenotfound',
        //     component: () =>
        //         import ('@/components/common/pageNotFound.vue')
        // }
    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 500)
        })
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js